import { render, staticRenderFns } from "./Predictive.vue?vue&type=template&id=cd20bbea"
import script from "./Predictive.vue?vue&type=script&lang=js"
export * from "./Predictive.vue?vue&type=script&lang=js"
import style0 from "./Predictive.vue?vue&type=style&index=0&id=cd20bbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports